import React from "react";
import { Helmet } from "react-helmet";
import Banner from "../../../component/Banner";
import image1 from "../../../images/manufacturing/manufacturing3.webp";
import { Link } from "react-router-dom";
const MiningMetal = () => {
  const banner = {
    title: "Mining & Metal Solutions ",
    image: image1,
  };

  return (
    <>
      <Helmet>
        <title>
        Mining and Metal Solutions — Cylon Technologies – Big Data | Data Analytics | Digital Strategy
        </title>
      </Helmet>
      <Banner heading={banner.title} bannerimg={banner.image} />
      <section className="sec-padd page_content heading_space pb-5 small_ul">
        <div className="container">
          <div className="row g-md-5 g-4 justify-content-between">
            <div className="col-md-7">
              <h2 className="heading2">Mining and Metal Solutions </h2>
              <p>
              Mining and metal companies are required to address the challenges of optimizing their processes and operations along with keeping up their equipment operational while also ensuring the safety of their staff. In addition, these companies face numerous issues in the form of diminishing margins, shortage of power and raw materials, escalating energy, transportation, labor and equipment costs.
              </p>
              <p>
              In the face of environmental concerns pertaining to global warming, carbon trading, and anti-pollution legislation - the need for better asset management and cost control cannot be underestimated and as such to manage these concerns you need an integrated view of your entire mining and metal production and operations.
              </p>
              <p>
              To take advantage of the comprehensive, IP –enabled technologies requires digital solutions that help you in uniting, analyzing and managing your engineering data processes and supply chain in an intelligent and efficient way.
              </p>
              <p>
              Working with the industry leading partners, Cylon Technologies can help you in fully connecting and integrating all of your operational environments. We apply an integrated approach to amalgamating your existing IT network with our new, consolidated operational technology networks.
              </p>
              <p>
              Cylon Technologies would help you in achieving increased margins through a better understanding of your customer needs, minimized production variations, reduced costs and improved product quality. Our unique approach revolves around managing risks by focusing on optimizing your processes, assessing your structure and management systems, empowering your workforce and building skills needed to create a strong safety culture and sustain improvements in your operations.
              </p>
              <h5 className="mt-5 mb-4"><b>Benefits of Cylon Technologies Mining and Metal Solutions- An Overview
</b></h5>
              <p>
              Our Mining and Metal Solutions help you in the enablement of efficient, collaborative, safe and highly secure operations, resulting in a fully connected and converged pit to a port network.  The Mining and Metal proven solutions of Cylon Technologies keep your costs down and your profits up as with us you can –
              </p>
              <p>Resolve issues before they happen with preventive maintenance software solutions that help your assets produce the returns you need for stable operations, ensures warranty compliance and helps you get ahead of issues that can impact production.</p>
              <p>Centralize asset information with a Computerized Maintenance Management Systems or CMMS.

</p>


            </div>
            <div className="col-md-4">
              <div className="right_content">
                <div className="border-tb mb-5">
                  <h2 className="heading2 mt-0">Secure Operations for Mining – Boosting Safety, Visibility and Control</h2>
                  <p>
                  Cylon Technologies secure solutions unlock the Pit to Port Operational solutions that enable new levels of operational agility that increases margin by being in control of cost and asset utilization. We have expertise in providing supply chain planning and execution services, spanning management of suppliers and distributors and facilitating optimum use of available capacities by providing standardized business processes.
                  </p>
                  <p>Cylon Technologies help you transform your mining and metal operations through our unique Mining Solutions through-</p>
                  <ul>
                    <li>Value Chain Optimization</li>
                    <li>
                    Production Optimization
                    </li>
                    <li>
                    Asset Performance Management
                    </li>
                    <li>Next Generation Workforce </li>
                    <li>Production Optimization</li>

                  </ul>
                  <p>
                  Our complete solutions for the metals industry empower you in optimizing production and plant operations while achieving safety and sustainability goals. We make industry 4.0 a reality in your operation with our cutting edge technology and applications that are built to solve your biggest industry challenges through technologies such as-
                  </p>
                  <ul>
                    <li>Cloud</li>
                    <li>Internet of Things
                    </li>
                    <li>Blockchain</li>
                  </ul>
                  <p>Cylon Technologies has tools and solutions to transform forward thinking companies for the future focusing on resources where they are most needed. For more information for your Mining and Metal Solutions – Contact Us-   <Link to="mailto:info@cylontechnology.com">info@cylontechnology.com</Link></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default MiningMetal;
